import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ISagaCb } from '@typings/requestPayloads'

export interface IAvailableTablesPayload extends ISagaCb {
    hallId?: string
    startDate?: string
    endDate?: string
}

export interface IAvailableTablesState {
    status: string
    data: any
    errors: any
}

const initialState: IAvailableTablesState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const availableTables = createSlice({
    name: 'table/available-tables',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IAvailableTablesPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload.data
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const availableTablesActions = availableTables.actions
export default availableTables.reducer
